import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PricingDashboardService {

  constructor(private http: HttpClient) {}

  getAddOnService(data:any): Observable<any> {
    return this.http.post(environment.getAddOnServices,data);
  }
}
